import React, { useEffect, useMemo, useState } from "react";
import { useTheme } from "@mui/material/styles";
import {
  Box,
  Button,
  CircularProgress,
  Divider,
  Fab,
  Grid,
  IconButton,
  InputAdornment,
  LinearProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import StopIcon from "@mui/icons-material/Stop";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import { gridSpacing } from "../../../store/constants";
import ViewEditDialog from "../../../utils/ui-components/ViewEditDialog";
import MainCard from "../../../utils/ui-components/MainCard";
import { closeConfirmDialog, openConfirmDialog } from "../../../utils/ui-components/pop-ups/ConfirmDialog";
import EmptyResult from "../../../utils/ui-components/EmptyResult";
import Spinner from "../../../utils/ui-components/Spinner";
import TablePaginationActions from "@mui/material/TablePagination/TablePaginationActions";
import AddContact from "./add-contact";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { ContactService } from "../../../assets/_services/contact-service";
import moment from "moment";
import PlayDisabledIcon from "@mui/icons-material/PlayDisabled";
import { openSuccessDialog } from "../../../utils/ui-components/pop-ups/SuccessDialog";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import TextFieldWrapper from "../../../utils/ui-components/FormsUI/TextField";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import { DataGrid, GridAlignment } from "@mui/x-data-grid";
import EmptyResultDataGrid from "../../../utils/ui-components/EmptyResultDataGrid";
import dayjs from "dayjs";

export interface ContactValues {
  contactName: string;
  // numbers: string;
  numberFile: Array<File>;
  // activeStatus: boolean;
}

function ContactList({ role }: any) {
  const { id } = useParams();
  const { state } = useLocation();
  const theme: any = useTheme();
  const navigate = useNavigate();

  const INITIAL_FORM_STATE: ContactValues = {
    contactName: "",
    // numbers: "",
    numberFile: [],
    // activeStatus: true,
  };
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingStatus, setIsLoadingStatus] = useState({
    loading: false,
    id: 0,
  });

  const [page, setPage] = useState(state?.page || 0);
  const [rowsPerPage, setRowsPerPage] = useState(state?.rowsPerPage || 10);
  const [count, setCount] = useState(state?.count || 0);
  const [search, setSearch] = useState(state?.otherData?.search || "");
  const [companyName, setCompanyName] = useState("");
  const matchDownSM = useMediaQuery(theme.breakpoints.down("md"));

  const [open, setOpen] = useState(false);
  const [contacts, setContacts] = useState([]);
  const [dialogTitle, setDialogTitle] = useState("");
  const [initialItem, setInitialItem] = useState(INITIAL_FORM_STATE);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });

  useEffect(() => {
    window.history.replaceState({}, "");
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchContactList(search);
  }, [paginationModel, search]);

  const fetchContactList = (searchValue: string) => {
    setIsLoading(true);
    let formData: any = {
      contactListName: searchValue,
    };
    if (role === 1) {
      formData = {
        ...formData,
        companyId: id,
      };
    }
    ContactService.getContactList(formData, paginationModel.page, paginationModel.pageSize).then((response) => {
      if (response.isSuccess) {
        setContacts(response.data.data.rows);
        setCompanyName(response.data.data.companyName);
        setCount(response.data.data.count);
      }
      setIsLoading(false);
    });
  };

  const changeStatusContact = (data: { id: number; status: number }) => {
    setIsLoadingStatus({
      loading: true,
      id: data.id,
    });
    closeConfirmDialog();
    let formData = {
      contactListId: data.id,
      status: data.status ? 0 : 1,
    };
    // ContactService.changeContactListStatus(formData).then((response) => {
    //   if (response.isSuccess) {
    //     openSuccessDialog("Success", response.data.comment);
    //     fetchContactList(search);
    //     setIsLoadingStatus({
    //       loading: false,
    //       id: 0,
    //     });
    //   } else {
    setIsLoadingStatus({
      loading: false,
      id: 0,
    });
    //   }
    // });
  };

  const handleClickOpen = (dialogTitle: string, formState: ContactValues) => {
    setOpen(true);
    setDialogTitle(dialogTitle);
    setInitialItem(formState);
  };

  const dialog = useMemo(
    () =>
      ViewEditDialog(AddContact)({
        open: open,
        setOpen: setOpen,
        dialogTitle: dialogTitle,
        initialItem: initialItem,
        fetchData: fetchContactList,
        theme: theme,
        maxWidth: "md",
        initialData: { creator: id, role: role },
      }),
    [open]
  );

  const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const columns = [
    // {
    //   field: "action",
    //   filterable: false,
    //   headerName: "",
    //   sortable: false,
    //   disableExport: false,
    //   width: 60,
    //   headerClassName: "stickyActionHeader",
    //   cellClassName: "stickyColumn",
    //   renderCell: (params: any) => {
    //     return (
    //       <Tooltip title="Edit">
    //         <IconButton
    //           aria-label="view"
    //           color="primary"
    //           onClick={() => {
    //             // handleClickOpen(`Update API User`, {
    //             //   id: params?.row?.id,
    //             //   accountType: Number(params?.row?.account_type) + 1 || "",
    //             //   assignChannelList: params?.row?.assignChannelList || [],
    //             //   confirmPassword: "",
    //             //   password: "",
    //             //   maskList: params?.row?.maskList || [],
    //             //   parentId: user.role === "1" ? state?.parentData?.id : user?.userId || "",
    //             //   purpose: params?.row?.purpose || "",
    //             //   rateCardId: params?.row.rate_card_id || "",
    //             //   status: params?.row?.status ? true : false,
    //             //   userName: params?.row?.user_name || "",
    //             // });
    //           }}
    //         >
    //           <VisibilityIcon
    //             fontSize="inherit"
    //             color="primary"
    //             // sx={{color: 'Background'}}
    //           />
    //         </IconButton>
    //       </Tooltip>
    //     );
    //   },
    // },
    {
      field: "id",
      filterable: true,
      headerName: "ID",
      sortable: true,
      disableExport: false,
      minWidth: 50,
      maxWidth: 60,
      flex: 1,
    },
    {
      field: "contact_list_name",
      filterable: true,
      headerName: "Name",
      sortable: true,
      disableExport: false,
      minWidth: 200,
      flex: 1,
    },
    {
      field: "valid_numbers",
      filterable: true,
      headerName: "Number Count",
      sortable: true,
      disableExport: false,
      minWidth: 120,
      maxWidth: 130,
      flex: 1,
      align: "right" as GridAlignment,
    },
    {
      field: "created_at",
      filterable: true,
      headerName: "Created Time",
      sortable: true,
      disableExport: false,
      minWidth: 160,
      maxWidth: 170,
      flex: 1,
      renderCell: (params: any) => {
        return (
          <Typography variant="caption" fontWeight={"bold"}>
            {dayjs(params.row?.created_at).format("DD MMM YYYY hh:mm:ss a")}
          </Typography>
        );
      },
    },
    {
      field: "updated_at",
      filterable: true,
      headerName: "Updated Time",
      sortable: true,
      disableExport: false,
      minWidth: 160,
      maxWidth: 170,
      flex: 1,
      renderCell: (params: any) => {
        return (
          <Typography variant="caption" fontWeight={"bold"}>
            {dayjs(params.row?.updated_at).format("DD MMM YYYY hh:mm:ss a")}
          </Typography>
        );
      },
    },
    // {
    //   field: "description",
    //   filterable: true,
    //   headerName: "Description",
    //   sortable: true,
    //   disableExport: false,
    //   minWidth: 200,
    //   flex: 2,
    // },
  ];

  return (
    <Grid container justifyContent={"center"} spacing={2}>
      <Grid item xs={11}>
        <Divider textAlign={"center"}>
          <Typography sx={{ ...theme.typography.pageheader }}>
            <ContactMailIcon fontSize="medium" /> Number Base Management
          </Typography>
        </Divider>
      </Grid>
      {/* <Grid item xs={12}>
        <Fab
          color="primary"
          sx={{ position: "fixed", zIndex: 3, bottom: 16, right: 16 }}
          aria-label="add"
          onClick={() => handleClickOpen(`Create Contact List`, INITIAL_FORM_STATE)}
        >
          <AddIcon />
        </Fab>
      </Grid> */}
      <Grid item lg={11} md={12} sm={12} xs={12}>
        <Formik
          initialValues={{
            userName: "",
          }}
          validationSchema={Yup.object().shape({
            userName: Yup.string()
              .notRequired()
              .matches(/^[a-zA-Z0-9_]*$/, "Username can contain only letters, numbers, and underscores"),
          })}
          onSubmit={(values: any, { setSubmitting }) => {
            setSearch(values.userName || "");
            setPaginationModel({ ...paginationModel, page: 0 });
          }}
        >
          {({ values, dirty, isSubmitting, isValid, setFieldValue }) => (
            <Form>
              <Grid container columnSpacing={1} justifyContent={"flex-end"}>
                <Grid item>
                  <TextFieldWrapper
                    label="Search"
                    placeholder="Number base name.."
                    name="userName"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon />
                        </InputAdornment>
                      ),
                    }}
                    size={"small"}
                    sx={{ minWidth: "250px" }}
                    fullWidth={true}
                  />
                </Grid>
                <Grid item>
                  <Button color="primary" variant="contained" sx={{ ...theme.typography.customInput }} type="submit">
                    View
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    color="primary"
                    sx={{ ...theme.typography.customInput }}
                    variant="contained"
                    type="button"
                    fullWidth
                    disabled={open}
                    onClick={() => handleClickOpen(`Create Number Base`, INITIAL_FORM_STATE)}
                    startIcon={<AddIcon />}
                  >
                    Create Number Base
                  </Button>
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
      </Grid>
      <Grid item lg={open && !matchDownSM ? 7 : 11} md={open && !matchDownSM ? 7 : 12} sm={12} xs={12}>
        <Box sx={{ minHeight: 400, width: "100%" }}>
          <DataGrid
            autoHeight
            columns={columns}
            loading={isLoading}
            rows={contacts}
            slots={{
              noRowsOverlay: EmptyResultDataGrid,
              loadingOverlay: () => <LinearProgress />,
            }}
            style={{ overflow: "auto" }}
            sx={{
              "& .MuiDataGrid-cell.stickyColumn": {
                position: "sticky",
                left: 0,
                backgroundColor: `${theme.palette.mode === "light" ? theme.palette.primary.light : theme.palette.background.paper}`,
                zIndex: 1,
              },
              "& .clicked-row": {
                backgroundColor: `${theme.palette.mode === "light" ? theme.palette.secondary.light : theme.palette.background.footer} !important`,
              },
              // cursor: "pointer",
            }}
            // getRowClassName={(params) => (params.id === initialItem.id ? "clicked-row" : "")}
            pagination
            getRowId={(row: any) => row.id}
            paginationMode="server"
            rowCount={count}
            disableRowSelectionOnClick
            pageSizeOptions={[5, 10, 25, 50, 100]}
            paginationModel={paginationModel}
            onPaginationModelChange={setPaginationModel}
          />
        </Box>
      </Grid>
      {open && !matchDownSM ? (
        <Grid item lg={5} md={5}>
          <MainCard title={dialogTitle}>
            {/* {initialItem?.id ? (
              <AddContact
                initialItem={initialItem}
                setOpen={setOpen}
                fetchData={fetchApiUserList}
                initialData={{
                  rateCards: rateCards,
                  //channels: channels,
                  parentId: state?.parentData?.id,
                }}
              />
            ) : ( */}
            <AddContact initialItem={initialItem} setOpen={setOpen} fetchData={fetchContactList} initialData={{ creator: id, role: role }} />
            {/* )} */}
          </MainCard>
        </Grid>
      ) : (
        dialog
      )}
    </Grid>
  );
}

export default ContactList;
